export const NEW_CHAT_TITLE = 'New Chat';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
